<template>
  <div>
    <Title :pages="[{ icon: 'user-tie', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn flat class="mb-3 btn-second" @click="updateDialog(true)">Crear {{ modal_title }}</v-btn>
      <v-btn outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportExcel(true)">Importar {{ modal_title
        }}</v-btn>

      <Modal :button_name="'Crear ' + modal_title" :modal_title="modal_title" :page_title="page_title"
        :formBtn="formBtn" :dialog="dialog" :service="service" @updateDialog="updateDialog"
        @loadList="loadList(service)" :editItem="mainItem" :isClient="isClient()" />

      <ModalImportExcel v-if="create_access" :button_name="'Importar ' + modal_title" :modal_title="modal_title"
        :page_title="page_title" formBtn="Importar" :dialog="dialog_import_excel" :service="service"
        @updateDialog="updateDialogImportExcel" @loadList="loadList(service)" :isClient="isClient()" />

      <v-card class="mb-4" v-if="!isClient()">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3" v-if="!isClient()">
                  <v-combobox v-model="filters.client" density="comfortable" name="cliente" item-title="name"
                    item-value="id" :items="clients" label="Cliente" autocomplete="off" :disabled="disabled"
                    clearable></v-combobox>
                </div>


                <div class="col-md-9 mt-2" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar"
                density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :items-per-page="0" :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..." :hide-default-footer="true">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td v-if="!isClient()">{{ item.client.name }}</td>
              <td>{{ item.mail }}</td>
              <td>{{ item.phone }}</td>
              <td>{{ item.address + ", " + item.location }}</td>
              <td class="text-center" style="min-width: 150px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2"
                      v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small">
                      mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2"
                      v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <div class="text-right mt-2">
        <small class="text-grey">
          {{ paginationText }}
        </small>
      </div>
      <v-pagination
        v-if="cant_pages > 1"
        v-model="current_page"
        :length="cant_pages"
        total-visible="10"
        @next="loadPage(service)"
        @prev="loadPage(service)"
        @first="loadPage(service)"
        @update:modelValue="loadPage(service)"
        class="mt-4"
      ></v-pagination>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    </v-container>
  </div>
</template>

<script>
import { subClientService } from "@/libs/ws/subClientService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./Modal.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import { clientService } from "@/libs/ws/clientService";

export default {
  components: { Modal, ModalImportExcel },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      service: subClientService,
      page_title: "Punto de entrega",
      modal_title: "Punto de entrega",
      dialog_import_excel: false,
      filters: {
        client: null,
      },
      clients: [],
      current_page: 1,
      cant_pages: 0,
      paginationText: "",
      headers: [
        {
          title: "Nombre",
          align: "left",
          sortable: true,
          key: "name",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client.name",
          visible_for_client: false,

        },
        {
          title: "Email",
          align: "left",
          sortable: true,
          key: "mail",
        },
        {
          title: "Telefono",
          align: "left",
          sortable: true,
          key: "phone",
        },
        {
          title: "Direccion",
          align: "left",
          sortable: true,
          key: "address",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
    };
  },
  mounted() {
    this.loadList(this.service);
    this.loadClientes();

    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

  },
  methods: {
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    getFilterParams() {
      return this.filters;
    },
    filter() {
      this.current_page = 1;
      this.loadList(this.service);
    },
    updateDialogImportExcel(value) {
      if (!value) {
        this.loadList(this.service);
      }
      this.dialog_import_excel = value;
    },
  },
};
</script>
